import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/table.css'
import config from './config/env.js'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 设置页面标题
document.title = config.title

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')